/** Lands the browser after a single sign-on round trip. The access token
 *  arrives in the URL fragment, so it never reaches a server log. */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Lockup } from "@/components/Logo";
import { ErrorState } from "@/components/States";
import { useSession } from "@/lib/session";

export function SignInComplete() {
  const { adoptToken } = useSession();
  const navigate = useNavigate();
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get("access_token");
    if (!token) {
      navigate("/sign-in", { replace: true });
      return;
    }
    // Clear the fragment before doing anything else.
    window.history.replaceState(null, "", window.location.pathname);
    adoptToken(token)
      // Single sign-on landed every administrator in room search, because this
      // navigated to "/" whatever the person could do. Not a race like the
      // password path — simply always wrong.
      .then(({ administers }) => navigate(administers ? "/admin" : "/", { replace: true }))
      .catch(setError);
  }, [adoptToken, navigate]);

  if (error) {
    return (
      <div className="page page--narrow">
        <ErrorState error={error} onRetry={() => navigate("/sign-in")} />
      </div>
    );
  }

  return (
    <div className="auth__panel" style={{ alignItems: "center", minHeight: "100vh" }}>
      <Lockup height={32} />
      <p className="t-body ink-secondary">Completing sign-in…</p>
    </div>
  );
}
